import { render } from "./icon-previous.svg?vue&type=template&id=77235fa4"
const script = {}

import exportComponent from "/home/rufi512/Documentos/Proyectos/ecommerce-product-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__